import * as React from 'react';
import AddressInput from '../../molecules/SearchMobile/AddressInput';

const SearchAddress = () => (
  <div className="search-mobile-fullpage">
    <AddressInput />
  </div>
);

export default SearchAddress;
